// Module
var code = `<CreateAlertWidget instrument="{{instrument}}" account="{{account}}" />

<div class="create-alert-panel">
    <CreateAlertAccountLookup account="{{account}}" visible="{{!.isUpdate}}" />
    <CreateAlertInstrumentLookup account="{{account}}" instrument="{{instrument}}" visible="{{!.isUpdate}}" isSymbolInfoOpened="{{isSymbolInfoOpened}}" />

    <CreateAlertActionSelector instrument="{{instrument}}"
                               value="{{alertActionValue}}"
                               visibleInfoBtn="{{.visibleInfoBtn}}"
                               visible="{{.isAlertActionSelectorVisible}}" />

    <CreateAlertOrderParametrsSelector instrument="{{instrument}}"
                                       visibleInfoBtn="{{.visibleInfoBtn}}"
                                       orderParam="{{.orderParam}}"
                                       infoBtnTooltip="{{.infoBtnTooltip}}"
                                       on-showOrderEntryEvent="showOrderEntryEvent"
                                       name="CreateAlertOrderParametrsSelector"
                                       visible="{{.showOrderParametrs}}"
                                       isOEOpened="{{isOEOpened}}" />

    <CreateAlertNotificationSelector instrument="{{instrument}}"
                                     selectedValue="{{.alertNotifyValue}}"
                                     selectedItem="{{selectedAlertNotifyItem}}" />

    <CreateAlertTypeSelector instrument="{{instrument}}"
                             value="{{.alertTypeValue}}"
                             selectedItem="{{selectedAlertTypeItem}}" />

    <CreateAlertConditionSelector instrument="{{instrument}}"
                                  value="{{.alertConditionValue}}" />

    <CreateAlertValueSelector instrument="{{instrument}}"
                              numericValue="{{.alertValue}}"
                              selectedItem="{{selectedAlertTypeItem}}" />

    <CreateAlertImportanceSelector instrument="{{instrument}}"
                                   value="{{alertImportanceValue}}" />

    <CreateAlertExpirationSelector on-timeLookupOpened="timeLookupOpened"
                                   on-timeLookupClosed="timeLookupClosed"
                                   expirationTime="{{.expirationTime}}" 
                                   datePickerButtons="{{datePickerButtons}}"/>

    <CreateAlertExecuteSelector instrument="{{instrument}}"
                                value="{{alertExecuteValue}}" />

    {{#if .isVisibleOTHTrading}}
        <overnightExecutionControlRactive isActive="{{isAllowOTHTrading}}" 
                                        textKey="{{overnightExecutionTextKey}}" 
                                        tooltipKey="{{isAllowOTHTrading ? overnightExecutionTooltipKeyActive : overnightExecutionTooltipKeyInActive}}" 
                                        controlWidth="200" 
                                        events="{{isAllowOTHTradingEvents}}"/>
    {{/if}}

    <CreateAlertMessageSelector account="{{account}}"
                                instrument="{{instrument}}"
                                alertValue="{{.alertValue}}"
                                alertType="{{.alertTypeValue}}"
                                alertCondition="{{.alertConditionValue}}"
                                messageText="{{.messageText}}" 
                                isMessageTextValid="{{.enabledCreateAlert}}" />
</div>`;
// Exports
export default code;